import { EXTERNAL_SCRIPT_ID, EXTERNAL_SCRIPT_SRC, SCRIPT_TAG } from "../constants/external-script-constants";
export const addScriptToDOM = ()=>{
    if (document.getElementById(EXTERNAL_SCRIPT_ID)) {
        return;
    }
    const script = document.createElement(SCRIPT_TAG);
    script.id = EXTERNAL_SCRIPT_ID;
    script.src = EXTERNAL_SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);
};
